<template>
  <form @submit.prevent="createSection()" action="">
    <ion-row>
      <ion-col size="12">
        <ion-list>
          <ion-item v-if="validationError" lines="none">
            <ion-label className="ion-text-wrap">
              <ion-text color="danger">
                <p v-for="error of v$.$errors" :key="error.$uid">
                  <ion-icon
                    :ios="alertCircleOutline"
                    :md="alertCircleSharp"
                    size="small"
                    style="vertical-align: middle"
                  ></ion-icon
                  >{{ error.$property }}: {{ error.$message }}
                </p></ion-text
              >
            </ion-label>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.session_id.$error }">
            <ion-label position="floating">Session</ion-label>
            <ion-select v-model="session_id" :value="session_id">
              <ion-select-option
                v-for="session of sessions"
                :key="session.id"
                :value="session.id"
              >
                {{ session.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.bill_id.$error }">
            <ion-label position="floating">Bill</ion-label>
            <ion-select v-model="bill_id" :value="bill_id">
              <ion-select-option
                v-for="bill of bills"
                :key="bill.id"
                :value="bill.id"
              >
                {{ bill.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.fee_id.$error }">
            <ion-label position="floating">Fee</ion-label>
            <ion-select v-model="fee_id" :value="fee_id">
              <ion-select-option
                v-for="fee of fees"
                :key="fee.id"
                :value="fee.id"
              >
                {{ fee.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.standard_id.$error }">
            <ion-label position="floating">Standard</ion-label>
            <ion-select v-model="standard_id" :value="standard_id">
              <ion-select-option
                v-for="standard of standards"
                :key="standard.id"
                :value="standard.id"
              >
                {{ standard.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.invoice_id.$error }">
            <ion-label position="floating">Invoice Number</ion-label>
            <ion-input type="number" v-model="invoice_id"></ion-input>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="6">
        <ion-button
          type="button"
          expand="full"
          color="warning"
          class="ion-margin-vertical"
          @click="resetFilters"
        >
          Reset
        </ion-button>
      </ion-col>
      <ion-col size="6">
        <ion-button type="submit" expand="full" class="ion-margin-vertical">
          Save
        </ion-button>
      </ion-col>
    </ion-row>
  </form>
</template>

<script>
import {
  IonRow,
  IonCol,
  IonList,
  IonLabel,
  IonItem,
  IonSelect,
  IonSelectOption,
  IonIcon,
  IonButton,
  IonInput,
  IonText,
  loadingController,
  alertController,
} from "@ionic/vue";

// import { alertCircleOutline, alertCircleSharp } from "ionicons/icons";

import { integer, maxLength, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  emits: ["closeModal"],
  components: {
    IonRow,
    IonCol,
    IonList,
    IonLabel,
    IonItem,
    IonSelect,
    IonSelectOption,
    IonIcon,
    IonButton,
    IonInput,
    IonText,
  },
  data() {
    return {
      session_id: null,
      bill_id: null,
      fee_id: null,
      standard_id: null,
      invoice_id: null,

      validationError: null,

      // alertCircleOutline,
      // alertCircleSharp,

      // xhrError: {
      //   header: null,
      //   description: null,
      // },
    };
  },

  computed: {
    sessions() {
      return this.$store.getters["session/allResources"];
    },
    bills() {
      return this.$store.getters["bill/allResources"];
    },
    fees() {
      return this.$store.getters["fee/allResources"];
    },
    standards() {
      return this.$store.getters["standard/allResources"];
    },

    filters() {
      return this.$store.getters["invoice/filters"];
    },
  },

  setup() {
    return { v$: useVuelidate() };
  },

  validations() {
    return {
      session_id: {
        integer: helpers.withMessage("can only be integers", integer),
      },
      bill_id: {
        integer: helpers.withMessage("can only be integers", integer),
      },
      fee_id: {
        integer: helpers.withMessage("can only be integers", integer),
      },
      standard_id: {
        integer: helpers.withMessage("can only be integers", integer),
      },
      invoice_id: {
        integer: helpers.withMessage("can only be integers", integer),
        maxLength: helpers.withMessage("maximum 9 characters", maxLength(9)),
      },
    };
  },

  methods: {
    setModalState(state) {
      this.modalState = state;
    },

    loader(message) {
      const loading = loadingController.create({
        message: message,
        backdropDismiss: false,
      });

      return loading;
    },

    alerter(header, message, buttons = ["close"]) {
      const alert = alertController.create({
        header: header,
        message: message,
        buttons: buttons,
      });

      return alert;
    },

    setErrorResponse(error) {
      if (error.response) {
        this.xhrError.header = error.response.data.header;
        this.xhrError.message = error.response.data.message;
      } else if (error.request) {
        this.xhrError.header = error.message || error.request;
        this.xhrError.message = "Please check your connection and try again";
      } else {
        this.xhrError.header = error.message;
        this.xhrError.message = "Something went wrong. Try again later";
      }
    },

    async createSection() {
      this.v$.$touch();
      if (this.v$.$error) {
        this.validationError = true;
        return;
      }

      let data = {
        session_id: this.session_id,
        bill_id: this.bill_id,
        fee_id: this.fee_id,
        standard_id: this.standard_id,
        invoice_id: this.invoice_id,
      };

      const spinner = await this.loader("Saving...");
      spinner.present();

      try {
        await this.$store.dispatch("invoice/filters", data);
        spinner.dismiss();
        this.$emit("closeModal");
      } catch (error) {
        spinner.dismiss();

        this.setErrorResponse(error);

        const alertDialog = await this.alerter(
          this.xhrError.header,
          this.xhrError.message
        );

        alertDialog.present();

        this.password = null;
        this.validationError = null;
      }
    },

    async fetchSessions() {
      await this.$store.dispatch("session/allResources");
      this.session_id = this.filters.session_id;
    },
    async fetchBills() {
      await this.$store.dispatch("bill/allResources");
      this.bill_id = this.filters.bill_id;
    },
    async fetchFees() {
      await this.$store.dispatch("fee/allResources");
      this.fee_id = this.filters.fee_id;
    },
    async fetchStandards() {
      await this.$store.dispatch("standard/allResources");
      this.standard_id = this.filters.standard_id;
    },

    resetFilters() {
      this.session_id = null;
      this.bill_id = null;
      this.fee_id = null;
      this.standard_id = null;
    },
  },

  created() {
    this.fetchSessions();
    this.fetchBills();
    this.fetchFees();
    this.fetchStandards();
  },
};
</script>